import { render, staticRenderFns } from "./Parc.vue?vue&type=template&id=4351dc20&"
import script from "./Parc.vue?vue&type=script&lang=js&"
export * from "./Parc.vue?vue&type=script&lang=js&"
import style0 from "./Parc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports